import {
  CSSVariablesResolver,
  MantineProvider,
  v8CssVariablesResolver,
} from '@mantine/core'
import React, { useMemo } from 'react'

import { useTheme } from '@v2/domains/ui/hooks/useTheme.hook'

// TODO(mantine-9-cleanup): delete with the v8 compatibility layer.
export const composeCssVariablesResolvers = (
  customResolver: CSSVariablesResolver,
): CSSVariablesResolver => {
  return (mantineTheme) => {
    const v8 = v8CssVariablesResolver(mantineTheme)
    const custom = customResolver(mantineTheme)
    return {
      variables: { ...v8.variables, ...custom.variables },
      light: { ...v8.light, ...custom.light },
      dark: { ...v8.dark, ...custom.dark },
    }
  }
}

const ThemeProviderAdapter: React.FC<React.PropsWithChildren<object>> = ({
  children,
}) => {
  const { getMantineThemeConfig } = useTheme()
  const { theme, cssVariablesResolver } = getMantineThemeConfig()

  const composedResolver = useMemo<CSSVariablesResolver>(
    () => composeCssVariablesResolvers(cssVariablesResolver),
    [cssVariablesResolver],
  )

  return (
    <MantineProvider
      theme={theme}
      cssVariablesResolver={composedResolver}
      withGlobalClasses
    >
      {children}
    </MantineProvider>
  )
}

export default ThemeProviderAdapter
